// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CurrencyMaskController from "./currency_mask_controller"
application.register("currency-mask", CurrencyMaskController)

import FullscreenController from "./fullscreen_controller"
application.register("fullscreen", FullscreenController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IdleController from "./idle_controller"
application.register("idle", IdleController)

import KioskSearchController from "./kiosk_search_controller"
application.register("kiosk-search", KioskSearchController)

import NestedSlidesController from "./nested_slides_controller"
application.register("nested-slides", NestedSlidesController)

import OnScreenKeyboardController from "./on_screen_keyboard_controller"
application.register("on-screen-keyboard", OnScreenKeyboardController)

import PerformanceChartController from "./performance_chart_controller"
application.register("performance-chart", PerformanceChartController)

import ScreenSaverController from "./screen_saver_controller"
application.register("screen-saver", ScreenSaverController)

import StaffPickerController from "./staff_picker_controller"
application.register("staff-picker", StaffPickerController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
